import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('creation'),
    createInApprovalMax: defineMessage('create_in_approvalmax'),
    description: defineMessage('add_users_who_should_be_ubmit_them_for_approval'),
};
